import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getSiteSettings,
  addSiteSetting as addLang,
} from "../../services/siteSettingService";
import { toast } from "react-toastify";

const initialState = {
  siteSettings: [],
  status: "idle", // "idle" | "loading" | "succeeded" | "failed"
  error: null,
};

// Fetch all siteSettings
export const fetchSiteSettings = createAsyncThunk(
  "siteSettings/fetchSiteSettings",
  async ({name}, { rejectWithValue }) => {
    try {
      const response = await getSiteSettings(name);
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
      return rejectWithValue(error.response?.data?.message || "An error occurred");
    }
  }
);

// Add a new siteSetting
export const addSiteSetting = createAsyncThunk(
  "siteSettings/addSiteSetting",
  async ({siteSetting,name}, { rejectWithValue }) => {
    try {
      const response = await addLang(siteSetting,name);
      toast.success(response.message || "Data added successfully!");
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
      return rejectWithValue(error.response?.data?.message || "An error occurred");
    }
  }
);



const siteSettingSlice = createSlice({
  name: "siteSettings",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch SiteSettings
      .addCase(fetchSiteSettings.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchSiteSettings.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.siteSettings = action.payload.data;
      })
      .addCase(fetchSiteSettings.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      

        // Add SiteSetting
            .addCase(addSiteSetting.fulfilled, (state, action) => {
              state.siteSettings.unshift(action.payload.data); // Add at the beginning
            })
      

     
  },
});

export const { clearError } = siteSettingSlice.actions;
export default siteSettingSlice.reducer;
